
import "../App.css";
import { Route, Redirect } from "react-router-dom";
import React, {useEffect} from 'react'



function ProtectedRoutes({ component: Component, ...rest }) {



  const token = localStorage.getItem('Token');

    useEffect(()=>{

    },[token])
  return (
    <Route
      {...rest}
      render={(props) => {
        if (token) {
          return <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: "/home",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
}

export default ProtectedRoutes;